module.exports = __webpack_public_path__ + "spine/building_celebration_6x9.json?b7d8874cb3a510419d010b70166331e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/building_construction/building_celebration_6x9.json
// module id = 1755
// module chunks = 3